// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__1VFqg","errorLogs":"EditorFooter_errorLogs__3Sn7m"};